import React from "react";
import { GlobalContext, I18nState } from "@flights/types";

declare global {
  interface Window {
    __I18N_STATE__: I18nState | undefined;
    gtag: any;
    loadTagManager?: Function;
    ga?: Function;
    riskifiedBeaconLoad: Function;
    dataLayer: any[];
  }
}

export default React.createContext<GlobalContext>({
  requestId: "",
  userAgent: {},
  availableLocales: [],
  features: {},
  auth: { enabled: true, clientId: "", redirectUri: "", isAuthenticatedOnWeb: false },
  supplierFeatures: [],
  isFlightsDomain: true,
  shouldNotTrack: false,
  apiPrefix: "",
  myIp: "",
  searchHistory: [],
  voidExcludedCountries: [],
  rebookExcludedCountries: [],
  isPaymentCollectionPage: false,
  mapsApiKeys: {
    GOOGLE: "",
    BAIDU: ""
  }
});
